<template>
  <b-card class="text-center">
    <template #header>
      Team members locations
    </template>
    <div class="ml-4 mr-4">
      <div v-for="(location, index) in locations" :key="location.location">
        <hr v-if="index > 0" class="m-4" />
        <h5 v-if="location.location" class="font-weight-bold">{{location.location}}</h5>
        <h6 v-else class="color-gray font-italic">Complete your profile</h6>
        <div v-if="location.timezone">{{location.timezone}}</div>
        <div class="d-flex justify-content-center mt-4 mb-4">
          <b-link
            v-for="profile in location.profiles"
            :key="profile.id"
            :to="{ name: 'UserProfile', params: { userId: profile.id } }"
          >
            <avatar
              :src="profile.photo"
              size="1.875rem"
              class="mr-2 ml-2"
            />
          </b-link>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import Avatar from '@/components/common/Avatar'
import { getTimezone } from '@/helpers/helpers'

export default {
  name: 'TeamMembersLocation',

  props: {
    members: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    locations() {
      const data = Object.values(this.members).reduce((out, profile) => {
        const location = profile.officeLocation || ''
        let timezone = ''
        if (profile.timezone) {
          const tz = getTimezone(profile.timezone)
          timezone = tz ? tz.label : ''
        }

        const key = `${location} - ${timezone}`
        if (out[key]) {
          out[key].profiles.push(profile)
        } else {
          out[key] = { location, timezone, profiles: [profile] }
        }
        return out
      }, {})

      return Object.values(data)
    }
  },

  components: {
    Avatar
  }
}
</script>
